import styled from 'styled-components'

const CardDetails = styled.div`
  margin-top: 5px;
  font-size: 12px;
  font-weight: bold;
`

export default CardDetails
